import './site.css';

/* trre2.com behaviour: pick the right film for the screen, play films only while visible, solid nav after the
   hero, the headline entrance, and the two forms. No framework; this page has to be fast on a phone at an auction. */

document.documentElement.classList.add('js');
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const saveData = (navigator as any).connection?.saveData === true;

/** Choose a source for a video: portrait film on tall screens when one exists; WebM where supported, else MP4. */
function sourceFor(v: HTMLVideoElement) {
  const tall = innerHeight / innerWidth > 1.15;
  const base = (tall && v.dataset.portrait) || v.dataset.landscape;
  if (!base) return null;
  const webm = v.canPlayType('video/webm; codecs="vp9"') !== '';
  return `${base}.${webm ? 'webm' : 'mp4'}`;
}
function load(v: HTMLVideoElement) { if (v.dataset.loaded) return; const src = sourceFor(v); if (!src) return; v.src = src; v.dataset.loaded = '1'; }
function play(v: HTMLVideoElement) { load(v); const p = v.play(); if (p) p.then(() => v.classList.add('playing')).catch(() => { /* autoplay refused: the poster stays */ }); }

// Hero film. On tall screens use the portrait cut and its poster straight away.
const tallScreen = innerHeight / innerWidth > 1.15;
const hero = document.querySelector<HTMLElement>('.hero');
const heroVideo = document.querySelector<HTMLVideoElement>('[data-hero-video]');
if (hero && heroVideo && tallScreen && heroVideo.dataset.portrait) { const p = `${heroVideo.dataset.portrait}-poster.jpg`; heroVideo.poster = p; hero.style.backgroundImage = `url('${p}')`; }
if (hero) requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('in')));
if (heroVideo && !reduce && !saveData) {
  heroVideo.preload = 'auto';
  play(heroVideo);
  new IntersectionObserver(([e]) => { if (e.isIntersecting) play(heroVideo); else heroVideo.pause(); }, { threshold: 0.05 }).observe(heroVideo);
}

// Films further down play while on screen
const inview = [...document.querySelectorAll<HTMLVideoElement>('[data-inview-video]')];
if (!reduce && !saveData) {
  const io = new IntersectionObserver(entries => entries.forEach(e => { const v = e.target as HTMLVideoElement; if (e.isIntersecting) play(v); else v.pause(); }), { threshold: 0.35 });
  inview.forEach(v => io.observe(v));
} else {
  // reduced motion: posters only, with native controls so a person can still choose to watch
  inview.forEach(v => { v.controls = true; v.preload = 'none'; load(v); });
}

// Nav turns solid once the hero is behind us
const nav = document.querySelector<HTMLElement>('[data-nav]');
if (nav) {
  const onScroll = () => nav.classList.toggle('solid', scrollY > (hero ? hero.offsetHeight - 80 : 10));
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
}
document.querySelectorAll('[data-year]').forEach(n => { n.textContent = String(new Date().getFullYear()); });

// Forms
const started = Date.now();
type Kind = 'property' | 'waitlist';
document.querySelectorAll<HTMLFormElement>('form[data-form]').forEach(form => {
  const kind = form.dataset.form as Kind;
  const msg = form.querySelector<HTMLElement>('.form-msg')!;
  const button = form.querySelector<HTMLButtonElement>('button[type=submit]')!;
  const say = (text: string, tone: 'ok' | 'err' | '' = '') => { msg.textContent = text; msg.className = `form-msg ${tone}`; };
  form.addEventListener('input', e => { (e.target as HTMLElement).removeAttribute('aria-invalid'); });
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(form).entries()) as Record<string, string>;
    const bad = (name: string, text: string) => { const el = form.elements.namedItem(name) as HTMLElement | null; el?.setAttribute('aria-invalid', 'true'); el?.focus(); say(text, 'err'); };
    if (kind === 'property') {
      if ((data.address ?? '').trim().length < 4) return bad('address', 'Add the property address.');
      if (!data.phone?.trim() && !data.email?.trim()) return bad('phone', 'Add a phone number or an email so we can reply.');
      if (data.email && !/^\S+@\S+\.\S+$/.test(data.email)) return bad('email', 'That email doesn’t look right.');
    } else if (!/^\S+@\S+\.\S+$/.test(data.email ?? '')) return bad('email', 'Enter your email to join the waitlist.');
    button.disabled = true; say('Sending…');
    try {
      const res = await fetch('/forms/inquiry', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ ...data, kind, started }) });
      const out = (await res.json().catch(() => ({}))) as { error?: string };
      if (!res.ok) throw new Error(out.error || 'The message didn’t go through.');
      form.reset();
      if (kind === 'property') { form.classList.add('sent'); say('Sent. Thank you. Someone from TRRE2 will reach out at the phone or email you gave.', 'ok'); }
      else say('You’re on the list. We’ll email you when TRRE OS opens to other investors.', 'ok');
    } catch (err) {
      say(`${(err as Error).message} Try again in a minute.`, 'err');
    } finally { button.disabled = false; }
  });
});
